module.exports = __webpack_public_path__ + "static/media/statement-dealer-logo.806597d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/statement-dealer-logo.svg
// module id = 7572
// module chunks = 0